<template>
  <Slide class="MessageSlide"
    v-bind="{ isCurrentSlide, isStartingSlide }"
    :title="content.title"
  >
    <p class="text">{{ content.text }}</p>
    <ul class="links">
      <li v-for="link in content.links" :key="link.url">
        <a :href="link.url" target="_blank" rel="noopener" class="link">{{ link.text }}</a>
      </li>
    </ul>
  </Slide>
</template>

<script>
import { slideProps } from '../util/slideBuilders.js'

import Slide from './elems/Slide.vue'

export default {
  components: {
    Slide,
  },
  props: slideProps,
}
</script>

<style scoped>
.text {
  color: var(--text-color-black);
}
.links {
  margin-top: var(--spacing-4);
  list-style: disc;
  padding-left: var(--spacing-8);
}
.link {
  color: var(--brand-color);
}
.link:hover {
  filter: brightness(0.85);
}
</style>
